import { Middleware } from 'redux';
import { REDO, UNDO } from '../actions';
import { Command } from '../commands/Command';
import RootState from '../RootState';

// Inspired by https://gist.github.com/CptLemming/d9e65e38b1e2091ae4dd

// const MB = 1048576;
const MAX_HISTORY = 100;
const MAX_DELAY = 100;

let lastCommandTime = 0;

const undoMiddleware: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    const flyerState = (store.getState() as RootState).flyer;
    const { pastCommands } = flyerState;
    if (action instanceof Command) {
      // execute
      const promise = action.execute(true);
      if (
        pastCommands.length &&
        Date.now() - lastCommandTime < MAX_DELAY &&
        Object.getPrototypeOf(action).constructor.name ===
          Object.getPrototypeOf(pastCommands[pastCommands.length - 1])
            .constructor.name &&
        action.canMerge
      ) {
        try {
          pastCommands[pastCommands.length - 1].merge(action);
        } catch {
          pastCommands.push(action);
        }
      } else {
        pastCommands.push(action);
      }
      flyerState.futureCommands = [];
      while (pastCommands.length > MAX_HISTORY) {
        pastCommands.shift();
      }
      console.log('HISTORY LENGTH', pastCommands.length);
      lastCommandTime = Date.now();
      // if (window.performance && (window.performance as any).memory) {
      //   const memory = (window.performance as any).memory;
      //   console.log('jsHeapSizeLimit', memory.jsHeapSizeLimit / MB, 'MB');
      //   console.log('totalJSHeapSize', memory.totalJSHeapSize / MB, 'MB');
      //   console.log('usedJSHeapSize', memory.usedJSHeapSize / MB, 'MB');
      // }
      return promise(store.dispatch, store.getState);
    } else if (action.type === UNDO) {
      const command = pastCommands.pop();
      console.log('HISTORY LENGTH', pastCommands.length);
      if (command !== undefined) {
        const promise = command.undo();
        flyerState.futureCommands.unshift(command);
        return promise(store.dispatch, store.getState);
      }
    } else if (action.type === REDO) {
      const command = flyerState.futureCommands.shift();
      if (command !== undefined) {
        const promise = command.execute();
        pastCommands.push(command);
        return promise(store.dispatch, store.getState);
      }
    } else {
      return next(action);
    }
  };

export { undoMiddleware };



// WEBPACK FOOTER //
// ./src/state/side-effects/undo.ts